import { createContext, useContext } from 'react';

export const MenuContext = createContext();
export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('MenuContext compound components cannot be rendered outside the MenuContext component');
  }
  return context;
};
